<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no"
    />
    <meta name="description" content="" />
    <meta name="author" content="" />

    <title>Carousel Template for Bootstrap</title>
  </head>
  <body class="adaptive-background">
    <div class="container-fluid">
      <div class="row row-carousel">
        <div class="col col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
        <div class="col col-sm-10 col-md-10 col-lg-10 col-xl-10">
          <div
            id="carouselExampleDark"
            class="carousel carousel-dark slide carousel-fade"
            data-bs-ride="carousel"
          >
            <div class="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="0"
                class="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide-to="2"
                aria-label="Slide 3"
              ></button>
            </div>
            <div class="carousel-inner">
              <div class="carousel-item active" data-bs-interval="5000">
                <img
                  src="/assets/images/a-propos/carousel/a-propos-equipe-sinepsy-diagnostic.png"
                  class="d-block w-100 img-carousel"
                  alt="image Sinepsy professionnel"
                />
                <div class="carousel-caption d-none d-md-block">
                  <h5>Professionnel</h5>
                  <p class="pcarousel">
                    Cabinet spécialisé dans la Psychologie clinique et
                    Neuropsychologie.
                  </p>
                </div>
              </div>
              <div class="carousel-item" data-bs-interval="5000">
                <img
                  src="/assets/images/a-propos/carousel/a-propos-equipe-sinepsy.png"
                  class="d-block w-100 img-carousel"
                  alt="image Sinepsy discrétion"
                />
                <div class="carousel-caption d-none d-md-block">
                  <h5>Discrétion</h5>
                  <p class="pcarousel">
                    Écoute authentique et respectueuse soumise au secret
                    professionnel
                  </p>
                </div>
              </div>
              <div class="carousel-item" data-bs-interval="5000">
                <img
                  src="/assets/images/a-propos/carousel/a-propos-equipe-sinepsy-réalité-virtuelle.png"
                  class="d-block w-100 img-carousel"
                  alt="image Sinepsy réalité virtuelle"
                />
                <div class="carousel-caption d-none d-md-block">
                  <h5>Innovant</h5>
                  <p class="pcarousel">
                    Nous avons mis en place des moyens technologiques modernes
                    pour vous accompagner.
                  </p>
                </div>
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleDark"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Précédent</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleDark"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Suivant</span>
            </button>
          </div>
        </div>
        <div class="col col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
      </div>
    </div>

    <br /><br />

    <div class="container marketing">
      <br />
      <h2>Présentation de l'équipe</h2>
      <br />
      <p>
        L'équipe est composée d'un psychologue spécialisé en neuropsychologie et
        psychologie clinique ainsi que de deux collaboratrices spécialisées en
        neuropsychologie.
      </p>

      <div class="row">
        <div class="col-lg-12 center-item">
          <img
            class="rounded-circle"
            src="/assets/images/a-propos/Sinepsy-photo-Santiago.png"
            alt="Generic placeholder image"
            width="140"
            height="140"
          />
          <h2>Santiago SAIN</h2>
          <p>
            <b style="font-size: 25px">"</b>
            Titulaire d'un diplôme en Psychologie délivré par l'Université de
            Cordoba (Argentine) et d'un Master en Psychologie Clinique de
            l'Université de Nantes, je suis un professionnel engagé dans
            l'accompagnement des personnes faisant face à des souffrances
            émotionnelles. Depuis 2015, mon expertise consiste à faciliter la
            compréhension des difficultés émotionnelles de mes patients et à
            mettre en œuvre des stratégies personnalisées visant à les aider à
            surmonter leurs épreuves. Mon engagement dans le domaine de la
            neuropsychologie remonte à 2013 où j'ai travaillé avec des patients
            présentant divers troubles neuropsychologiques.
            <br /><br />Passionné par mon métier, je désire approfondir
            continuellement mes connaissances, tout en partageant mon expertise
            à travers des cours dispensés à l'université, destinés aux étudiants
            en psychologie. Mon parcours professionnel reflète mon dévouement
            envers l'amélioration constante de mes compétences et ma volonté de
            contribuer activement au domaine de la psychologie.<b
              style="font-size: 25px"
              >"</b
            >
          </p>
        </div>
      </div>

      <hr class="featurette-divider" />

      <div class="row featurette ligne">
        <div class="col-md-7">
          <h2 class="featurette-heading">
            Nos services
            <span class="text-muted">pour vous accompagner.</span>
          </h2>
          <p class="lead">
            Notre équipe passionnée de professionnels qualifiés s'engage à
            fournir des services de qualité pour répondre à vos besoins en
            matière de santé mentale. En intégrant des approches modernes telles
            que la réalité virtuelle, nous offrons des outils innovants pour
            enrichir nos interventions thérapeutiques. Que ce soit pour traiter
            des troubles psychologiques, renforcer les compétences cognitives ou
            explorer des aspects spécifiques de votre fonctionnement mental,
            notre cabinet combine l'expertise clinique traditionnelle avec des
            solutions technologiques avancées.
          </p>
        </div>
        <div class="col-md-5">
          <img
            class="featurette-image img-fluid mx-auto scroll-animation"
            src="/assets/images/a-propos/a-propos-présentation-cabinet-equipement-réalité-virtuelle.png"
            alt="image-réalité-virtuelle"
            style="float: inline-end"
          />
        </div>
      </div>

      <hr class="featurette-divider" style="margin-top: auto" />

      <div class="row featurette ligne">
        <div class="col-md-7 order-md-2">
          <h2 class="featurette-heading">
            Le cabinet
            <span class="text-muted"
              >pour vous recevoir en toute discrétion.</span
            >
          </h2>
          <p class="lead">
            Le cabinet SINEPSY se situe 10 rue de Troènes 44600 Saint-Nazaire ,
            <u>à mon domicile</u> et est accessible sur
            <span
              class="partie-imp btn-rdv"
              data-bs-toggle="modal"
              data-bs-target="#modalRdv"
              style="cursor: pointer"
              >rendez-vous</span
            >
            du lundi au vendredi de 10h à 12h30 et de 14h à 18h.
          </p>
          <p class="lead">
            Vous pouvez y accéder en bus depuis... <br /><br /><span
              class="partie-imp"
              >Saint-Nazaire:</span
            >
            U4 ou C2 arrêt "Marsain". <br />
            <span class="partie-imp"> Pornichet:</span> Départ "Port d'echouage"
            L13, changement à la "Cité sanitaire" avec la ligne Helyces puis
            prendre le U4 à l'arrêt "Boris Vian", descendez à l'arrêt "Marsain".
          </p>
        </div>
        <div class="col-md-5 order-md-1 photoAPropos">
          <img
            class="featurette-image img-fluid mx-auto fullscreen-image scroll-animation"
            src="/assets/images/a-propos/Sinepsy-cabinet-psychologie.jpg"
            alt="image du cabinet"
          />
        </div>
      </div>

      <hr class="featurette-divider" />

      <div class="row featurette ligne">
        <div class="col-md-7">
          <h2 class="featurette-heading" id="sectionEnSavoirPlus">
            Le dispositif
            <span class="text-muted">"Mon soutien Psy".</span>
          </h2>
          <p class="lead">
            <span class="partie-imp"> Principe :</span> Ce dispositif s'adresse
            à toute personne à partir de 3 ans rencontrant une situation
            difficile. Il vous permet de bénéficier de 8 séances par an chez un
            psychologue expérimenté d'une durée de 30 minutes. <br /><br />
            <span class="partie-imp" style="color: rgba(255, 0, 0, 0.73)">
              /!\ Important :</span
            >
            Il est possible <u>d'étendre la durée des séances</u> au delà de 30
            minutes cependant seule les 30 premières minutes seront remboursées
            dans le cadre de Mon soutien psy. Pour les personnes de moins de 18
            ans, l'accord parental est obligatoire.<br /><br />
            <span class="partie-imp">la démarche :</span>
            <br /><br />
            <span class="partie-imp"> 1.</span> Aller chez votre médecin
            (généraliste, gynécologue, médecin scolaire, protection maternelle
            et infantile, etc.), il vous indiquera si Mon soutien psy est adapté
            à votre situation.
            <br />
            <span class="partie-imp"> 2.</span> Prenez rendez-vous avec votre
            cabinet Sinepsy soit par téléphone au
            <span class="partie-imp">06 50 56 47 42</span> soit sur internet
            <span
              class="partie-imp btn-rdv"
              data-bs-toggle="modal"
              data-bs-target="#modalRdv"
              style="cursor: pointer"
              >ici</span
            >.
            <br />
            <span class="partie-imp"> 3.</span> Faites vous rembourser en
            envoyant votre feuille de soins et le courrier d'adressage de votre
            médecin à votre organisme d'Assurance Maladie après chaque séance ou
            à la fin de plusieurs séances.
          </p>
        </div>
        <div class="col-md-5" style="text-align: center">
          <div>
            <img
              src="/assets/images/a-propos/à-propos-sinepsy-mon-soutien-psy.jpg"
              alt="image-mon-soutien-psy"
              class="featurette-image"
              style="float: inline-end"
            />
          </div>
        </div>
      </div>
      <br />
      <hr class="featurette-divider" style="margin-top: auto" />

      <div class="row featurette ligne">
        <div class="col-md-7 order-md-2">
          <h2 class="featurette-heading">
            Les prestations
            <span class="text-muted">que nous vous proposons.</span>
          </h2>
          <p class="lead">
            Nous vous invitons à prendre connaissance de nos tarifs en
            consultant notre grille tarifaire détaillée, soigneusement conçue
            pour refléter la gamme complète de services professionnels que nous
            mettons à votre disposition. Cette grille tarifaire vise à vous
            offrir une compréhension claire des coûts associés à chaque
            prestation, garantissant ainsi une relation professionnelle
            transparente. N'hésitez pas à nous contacter pour toute
            clarification ou information additionnelle concernant nos tarifs.
          </p>
        </div>
        <div class="col-md-5 order-md-1 photoAPropos image-container">
          <img
            (click)="activeClass()"
            id="imgTarif"
            class="featurette-image img-fluid mx-auto fullscreen-image scroll-animation"
            src="/assets/images/tarifs-Sinepsy.png"
            alt="image tarifs Sinepsy"
          />
        </div>
      </div>
    </div>
    <app-modal-rendez-vous></app-modal-rendez-vous>
    <script
      src="https://code.jquery.com/jquery-3.3.1.slim.min.js"
      integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo"
      crossorigin="anonymous"
    ></script>
    <script src="../../js/vendor/popper.min.js"></script>
    <script src="../../js/bootstrap.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/holderjs@2.9.4/holder.js"></script>
  </body>
</html>
